import Rollbar from 'rollbar'

interface RollbarPayload {
  body?: {
    trace?: {
      exception?: {
        description: string
      }
    }
  }
}

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN_UI,
  captureUncaught: true,
  captureUnhandledRejections: true,
  reportLevel: 'info',
  environment: process.env.APP_ENV,
  checkIgnore: function (isUncaught, args, payload) {
    return (
      (isUncaught && isBrowserExtension(args, payload)) || //ignore extensions
      (isUncaught && isThirdPartyScript(args, payload)) || //ignore third party scripts
      (isUncaught && isCohesionError(args, payload)) || //ignore some cohesiona error
      navigator.userAgent.indexOf('MSIE') !== -1 || // ignore all IE
      navigator.userAgent.indexOf('Trident') !== -1 || // ignore all IE
      navigator.userAgent.indexOf('Edge/1') !== -1 || // ignore old versions of Edge
      navigator.userAgent.indexOf('Chrome/49') !== -1 // ignore chrome 49
    )
  },
  payload: {
    environment: process.env.APP_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.CIRCLE_SHA1,
        guess_uncaught_frames: true
      }
    }
  },
  scrubFields: [
    'first_name',
    'last_name',
    'full_name',
    'phone',
    'email',
    'firstName',
    'lastName',
    'fullName',
    'address',
    'street_address',
    'streetAddress'
  ], // This list is appended to a default list of keys that rollbar deems pii as default

  /**
   * This transformer ensures that error mesaages sent from the UIs are also
   * prepended with the app name where they came from
   */
  transform: (payload: RollbarPayload) => {
    const msg = payload?.body?.trace?.exception?.description
    if (msg) {
      payload.body.trace.exception.description = `toolbox:${process.env.APP_NAME}: ${msg}`
    }
  }
}

export default new Rollbar(rollbarConfig)

const isThirdPartyScript = (args, payload) => {
  const stack = payload.body.telemetry[0]?.body?.stack
  return (
    stack &&
    (stack.includes('cohesionapps') ||
      stack.includes('googletagmanager') ||
      stack.includes('cookielaw'))
  )
}

const isBrowserExtension = (args, payload) => {
  return (
    payload.body.trace.frames[0].filename.indexOf('extension') !== -1 ||
    payload.body.trace.exception.class === '(unknown)' ||
    payload.body.trace.frames[0].filename === '(unknown)' ||
    payload.body.trace.frames[0].method === '[anonymous]'
  )
}

const isCohesionError = (args, payload) => {
  const ignoreList = ['Illegal invocation']
  const errorMsg = payload.body.trace.exception.message
  const lastFrame =
    payload.body.trace.frames[payload.body.trace.frames.length - 1]
  return (
    lastFrame?.filename?.includes('cdn.cohesionapps.com') &&
    ignoreList.includes(errorMsg)
  )
}
